<template>
  <div class="byl">
    <Header @to-login="toLoginPage" :txt="headerTxt" @to-logout="toLogout" @to-reg="toReg" @to-record="toRecord"></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>

import Header from '@/components/byl/header/header.vue'
import Footer from '@/components/byl/footer/footer.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: { Header, Footer },
  data () {
    return {
      headerTxt: '管理企业'
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    ...mapActions('auth', {
      logout: 'logout'
    }),
    toLoginPage () {
      // this.$router.push('/byl/login')
      window.location.href = window.location.origin + '/#/byl/login'
    },
    toLogout () {
      if (this.user) {
        this.logout()
      }
    },
    toReg () {
      // this.$router.push('/byl/orgreg')
      window.location.href = window.location.origin + '/#/byl/orgreg'
    },
    toRecord () {
      this.$router.push('/org')
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/index.vue